import { render, staticRenderFns } from "./SimulatorComposer.vue?vue&type=template&id=2038eba6&scoped=true&"
import script from "./SimulatorComposer.vue?vue&type=script&lang=js&"
export * from "./SimulatorComposer.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorComposer.vue?vue&type=style&index=0&id=2038eba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038eba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VChip,VTextarea})
